import { OptionProps } from "components/common/utlis/TypeAnnotations";

interface dropDownList {
  offices: OptionProps[];
  // agents: OptionProps[];
  status: OptionProps[];
  collegues: OptionProps[];
}
// Old: export const createFilterConfig = (dropDownList: dropDownList) => {
// isStatusDisabled: the Status filter is only usable on the "All" tab.
export const createFilterConfig = (dropDownList: dropDownList, isStatusDisabled = false) => {
  return [
    {
      name: "office",
      options: dropDownList.offices,
      fieldType: "multiSelect",
      placeholder: "Office",
      filterType: "search",
    },
    {
      name: "contractNumber",
      fieldType: "text",
      placeholder: "Contract number",
      filterType: "search",
    },
    {
      name: "companyName",
      fieldType: "text",
      placeholder: "Customer",
      filterType: "search",
    },
    {
      name: "candidateName",
      fieldType: "text",
      placeholder: "Employee",
      filterType: "search",
    },
    {
      name: "employeeType",
      fieldType: "text",
      placeholder: "Employee type ",
      filterType: "search",
    },
    {
      name: "functionName",
      fieldType: "text",
      placeholder: "Function",
      filterType: "search",
    },
    {
      name: "pcNumber",
      fieldType: "text",
      placeholder: "PC",
      filterType: "search",
    },
    {
      name: "from",
      fieldType: "date",
      placeholder: "From",
      label: "From",
      filterType: "search",
    },
    {
      name: "to",
      fieldType: "date",
      placeholder: "To",
      label: "To",
      filterType: "search",
    },
    {
      name: "status",
      options: dropDownList.status,
      fieldType: "singleSelect",
      placeholder: "Status",
      filterType: "search",
      prefixClass: "selectSection",
      isDisabled: isStatusDisabled,
    },
  ];
};
